
import {catchError} from 'rxjs/operators';
import { Injectable } from '@angular/core';

import { FgiBackEndService } from '../fgi-back-end.service';
import { RespostaVersao } from '../../model/monitoracao.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MonitoracaoService extends FgiBackEndService<RespostaVersao> {

  // @Override (obrigado a sobrescrever. Nao faz sentido para o nosso caso.)
  getNewEntity() {
    return new RespostaVersao();
  }

  // @Override (obrigado a sobrescrever. Nao faz sentido para o nosso caso.)
  protected getResourceURL(): string {
    return 'monitoracao';
  }

 public getVersao() {
    return this.http.get('rest/integracao/monitoracao/versao').pipe(
      catchError((e) => this.handleError(e))) as Observable<RespostaVersao>;
  }
}
